export const categories = [
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'dongzuo', name: '动作', icon: 'ri-sword-line' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'juqing', name: '剧情', icon: 'ri-film-line' },
  { slug: 'xiaoyuan', name: '校园', icon: 'ri-building-line' },
  { slug: 'dushi', name: '都市', icon: 'ri-community-line' },
];

export interface ComicChapter {
  num: number;
  title: string;
  updateDate: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  categoryName: string;
  coverImage: string;
  description: string;
  chapters: ComicChapter[];
  rating: number;
  views: number;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  isCompleted: boolean;
  updateDate: string;
}

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '秘密花园',
    author: '金秀贤',
    category: 'lianai',
    categoryName: '恋爱',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20comic%20cover%20art%2C%20beautiful%20couple%20embracing%20in%20a%20flower%20garden%2C%20soft%20pastel%20color%20palette%2C%20dreamy%20atmosphere%2C%20watercolor%20texture%2C%20clean%20white%20background%2C%20vertical%20book%20cover%20layout%2C%20elegant%20and%20romantic%20art%20style&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '一个普通女孩意外进入富豪家族的秘密花园，在那里她遇到了改变她一生的爱情。当她逐渐揭开花园背后的秘密，才发现自己与这个家族有着不可分割的联系。',
    chapters: [
      { num: 1, title: '意外的相遇', updateDate: '2026-08-01' },
      { num: 2, title: '秘密花园', updateDate: '2026-07-28' },
      { num: 3, title: '心跳加速', updateDate: '2026-07-25' },
      { num: 4, title: '命运的齿轮', updateDate: '2026-07-22' },
      { num: 5, title: '无法言说的爱', updateDate: '2026-07-18' },
    ],
    rating: 9.6,
    views: 1250000,
    tags: ['恋爱', '豪门', '甜宠'],
    isHot: true,
    isNew: false,
    isCompleted: false,
    updateDate: '2026-08-01',
  },
  {
    id: 'comic-2',
    title: '猎魔人传说',
    author: '朴正宇',
    category: 'dongzuo',
    categoryName: '动作',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20comic%20cover%2C%20powerful%20demon%20hunter%20holding%20a%20glowing%20sword%2C%20dark%20atmosphere%20with%20dramatic%20lighting%2C%20intense%20expression%2C%20red%20and%20black%20color%20scheme%2C%20clean%20dark%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '在恶魔横行的世界里，一位年轻的猎魔人踏上了拯救人类的征程。他拥有特殊的能力，但也要面对内心的黑暗与挣扎。',
    chapters: [
      { num: 1, title: '觉醒', updateDate: '2026-08-02' },
      { num: 2, title: '初次战斗', updateDate: '2026-07-30' },
      { num: 3, title: '黑暗降临', updateDate: '2026-07-27' },
      { num: 4, title: '同伴', updateDate: '2026-07-24' },
      { num: 5, title: '深渊之门', updateDate: '2026-07-20' },
      { num: 6, title: '决战前夕', updateDate: '2026-07-16' },
    ],
    rating: 9.3,
    views: 980000,
    tags: ['动作', '奇幻', '热血'],
    isHot: true,
    isNew: false,
    isCompleted: false,
    updateDate: '2026-08-02',
  },
  {
    id: 'comic-3',
    title: '魔法学院的日常',
    author: '李恩智',
    category: 'qihuan',
    categoryName: '奇幻',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20comic%20cover%2C%20young%20students%20in%20a%20magical%20academy%20with%20floating%20spells%20and%20books%2C%20bright%20vibrant%20colors%2C%20whimsical%20atmosphere%2C%20magical%20effects%2C%20clean%20light%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '在闻名遐迩的艾伦魔法学院，一群性格迥异的学生们开始了他们的魔法学习之旅。友情、竞争与成长交织在一起，谱写出一段段精彩的故事。',
    chapters: [
      { num: 1, title: '入学典礼', updateDate: '2026-08-01' },
      { num: 2, title: '第一堂课', updateDate: '2026-07-29' },
      { num: 3, title: '魔法对决', updateDate: '2026-07-26' },
    ],
    rating: 9.1,
    views: 756000,
    tags: ['奇幻', '校园', '搞笑'],
    isHot: false,
    isNew: true,
    isCompleted: false,
    updateDate: '2026-08-01',
  },
  {
    id: 'comic-4',
    title: '深夜食堂',
    author: '崔敏浩',
    category: 'juqing',
    categoryName: '剧情',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20slice%20of%20life%20comic%20cover%2C%20warm%20night%20restaurant%20interior%20with%20steaming%20food%2C%20cozy%20atmosphere%2C%20soft%20warm%20lighting%2C%20emotional%20tone%2C%20clean%20warm%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '深夜，一家不起眼的小餐馆总是亮着温暖的灯光。形形色色的食客带着各自的故事走进来，在美食的陪伴下分享人生百态。',
    chapters: [
      { num: 1, title: '第一夜', updateDate: '2026-07-31' },
      { num: 2, title: '回家的路', updateDate: '2026-07-28' },
      { num: 3, title: '妈妈的食谱', updateDate: '2026-07-25' },
      { num: 4, title: '老友重逢', updateDate: '2026-07-22' },
    ],
    rating: 9.5,
    views: 632000,
    tags: ['剧情', '美食', '治愈'],
    isHot: false,
    isNew: false,
    isCompleted: true,
    updateDate: '2026-07-31',
  },
  {
    id: 'comic-5',
    title: '暗影追踪者',
    author: '韩志勋',
    category: 'xuanyi',
    categoryName: '悬疑',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20thriller%20comic%20cover%2C%20detective%20in%20trench%20coat%20walking%20through%20rainy%20alley%2C%20noir%20atmosphere%2C%20dark%20blue%20and%20gray%20tones%2C%20suspenseful%20mood%2C%20clean%20dark%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '连环失踪案件震惊全城，天才侦探韩志勋接手调查。随着线索一步步浮现，他发现自己也被卷入了一个巨大的阴谋之中。',
    chapters: [
      { num: 1, title: '失踪', updateDate: '2026-08-03' },
      { num: 2, title: '线索', updateDate: '2026-07-31' },
      { num: 3, title: '嫌疑人', updateDate: '2026-07-28' },
      { num: 4, title: '反转', updateDate: '2026-07-25' },
    ],
    rating: 9.4,
    views: 890000,
    tags: ['悬疑', '推理', '犯罪'],
    isHot: true,
    isNew: false,
    isCompleted: false,
    updateDate: '2026-08-03',
  },
  {
    id: 'comic-6',
    title: '爆笑校园日记',
    author: '张美英',
    category: 'gaoxiao',
    categoryName: '搞笑',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20school%20life%20comic%20cover%2C%20funny%20students%20making%20silly%20faces%20in%20classroom%2C%20bright%20colorful%20cartoon%20style%2C%20energetic%20and%20playful%20mood%2C%20clean%20white%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '高中生活充满了意想不到的趣事！一群活宝同学每天上演着让人捧腹大笑的日常，让你在欢笑中重温青春的美好时光。',
    chapters: [
      { num: 1, title: '开学第一天', updateDate: '2026-07-30' },
      { num: 2, title: '食堂大作战', updateDate: '2026-07-27' },
      { num: 3, title: '考试风云', updateDate: '2026-07-24' },
      { num: 4, title: '运动会', updateDate: '2026-07-21' },
      { num: 5, title: '学园祭', updateDate: '2026-07-18' },
    ],
    rating: 9.2,
    views: 1100000,
    tags: ['搞笑', '校园', '日常'],
    isHot: true,
    isNew: false,
    isCompleted: false,
    updateDate: '2026-07-30',
  },
  {
    id: 'comic-7',
    title: '我的人鱼男友',
    author: '尹素熙',
    category: 'lianai',
    categoryName: '恋爱',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20comic%20cover%2C%20beautiful%20mermaid%20prince%20and%20human%20girl%20by%20the%20ocean%20shore%2C%20shimmering%20blue%20water%2C%20dreamy%20romantic%20mood%2C%20soft%20pastel%20blue%20and%20pink%20tones%2C%20clean%20light%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '在海边小镇生活的少女小海，偶然救下了一位神秘的美男鱼。他来自深海王国，为了报答救命之恩留在了陆地上，一段跨越种族的浪漫爱情由此展开。',
    chapters: [
      { num: 1, title: '海边邂逅', updateDate: '2026-08-01' },
      { num: 2, title: '深海秘密', updateDate: '2026-07-28' },
      { num: 3, title: '人类生活', updateDate: '2026-07-25' },
      { num: 4, title: '王子的身份', updateDate: '2026-07-22' },
    ],
    rating: 9.7,
    views: 1450000,
    tags: ['恋爱', '奇幻', '甜宠'],
    isHot: true,
    isNew: false,
    isCompleted: false,
    updateDate: '2026-08-01',
  },
  {
    id: 'comic-8',
    title: '末日生存指南',
    author: '郑太浩',
    category: 'dongzuo',
    categoryName: '动作',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20post%20apocalyptic%20action%20comic%20cover%2C%20survivor%20with%20weapon%20in%20ruined%20city%2C%20dramatic%20orange%20sky%2C%20intense%20survival%20theme%2C%20gritty%20dark%20style%2C%20clean%20dark%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '一场突如其来的灾难让世界陷入混乱。主角必须在这个充满危险的末日世界中寻找生存之道，同时保护身边重要的人。',
    chapters: [
      { num: 1, title: '末日降临', updateDate: '2026-08-01' },
      { num: 2, title: '避难所', updateDate: '2026-07-28' },
      { num: 3, title: '物资争夺', updateDate: '2026-07-25' },
    ],
    rating: 9.0,
    views: 820000,
    tags: ['动作', '末日', '生存'],
    isHot: false,
    isNew: true,
    isCompleted: false,
    updateDate: '2026-08-01',
  },
  {
    id: 'comic-9',
    title: '办公室罗曼史',
    author: '金多英',
    category: 'dushi',
    categoryName: '都市',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20comic%20cover%2C%20elegant%20businessman%20and%20woman%20in%20modern%20office%2C%20sophisticated%20city%20vibe%2C%20warm%20professional%20color%20palette%2C%20romantic%20undertone%2C%20clean%20light%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '在首尔最顶尖的广告公司，两个竞争对手在职场中不断碰撞，却在不知不觉中擦出了爱情的火花。职场与爱情的双重考验即将开始。',
    chapters: [
      { num: 1, title: '新同事', updateDate: '2026-07-31' },
      { num: 2, title: '竞争开始', updateDate: '2026-07-28' },
      { num: 3, title: '加班之夜', updateDate: '2026-07-25' },
      { num: 4, title: '心动瞬间', updateDate: '2026-07-22' },
      { num: 5, title: '告白', updateDate: '2026-07-19' },
    ],
    rating: 9.3,
    views: 980000,
    tags: ['都市', '恋爱', '职场'],
    isHot: false,
    isNew: false,
    isCompleted: false,
    updateDate: '2026-07-31',
  },
  {
    id: 'comic-10',
    title: '异世界餐厅',
    author: '宋贤宇',
    category: 'qihuan',
    categoryName: '奇幻',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20isekai%20fantasy%20comic%20cover%2C%20chef%20in%20magical%20kitchen%20with%20floating%20ingredients%20and%20mystical%20creatures%2C%20warm%20glowing%20atmosphere%2C%20whimsical%20food%20theme%2C%20rich%20colors%2C%20clean%20light%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '一位天才厨师莫名穿越到了剑与魔法的异世界。在这个没有美食概念的世界里，他用料理征服了精灵、兽人和龙族，开起了异世界最受欢迎的餐厅。',
    chapters: [
      { num: 1, title: '穿越', updateDate: '2026-08-02' },
      { num: 2, title: '第一道菜', updateDate: '2026-07-30' },
      { num: 3, title: '精灵食客', updateDate: '2026-07-27' },
      { num: 4, title: '龙族的委托', updateDate: '2026-07-24' },
    ],
    rating: 9.4,
    views: 870000,
    tags: ['奇幻', '美食', '冒险'],
    isHot: true,
    isNew: false,
    isCompleted: false,
    updateDate: '2026-08-02',
  },
  {
    id: 'comic-11',
    title: '初恋这件小事',
    author: '朴恩惠',
    category: 'xiaoyuan',
    categoryName: '校园',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20high%20school%20romance%20comic%20cover%2C%20shy%20students%20under%20cherry%20blossom%20tree%2C%20spring%20atmosphere%2C%20soft%20pink%20and%20white%20petals%2C%20youthful%20innocent%20love%2C%20clean%20light%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '高中三年，一段纯真的初恋。两个性格截然不同的少年，在樱花树下许下了青春的约定。但这只是他们故事的开始。',
    chapters: [
      { num: 1, title: '春天来了', updateDate: '2026-07-30' },
      { num: 2, title: '同桌的你', updateDate: '2026-07-27' },
      { num: 3, title: '樱花约定', updateDate: '2026-07-24' },
    ],
    rating: 9.5,
    views: 1050000,
    tags: ['校园', '恋爱', '青春'],
    isHot: false,
    isNew: false,
    isCompleted: true,
    updateDate: '2026-07-30',
  },
  {
    id: 'comic-12',
    title: '犯罪心理分析师',
    author: '权志龙',
    category: 'xuanyi',
    categoryName: '悬疑',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20psychological%20thriller%20comic%20cover%2C%20profiler%20analyzing%20crime%20scene%20evidence%2C%20dark%20mysterious%20atmosphere%2C%20cold%20blue%20and%20gray%20tones%2C%20intense%20psychological%20theme%2C%20clean%20dark%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '前FBI犯罪心理分析师回到韩国后，被卷入了一系列离奇的连环杀人案。每一个案件都像是凶手精心设计的谜题，考验着他的专业能力与心理极限。',
    chapters: [
      { num: 1, title: '回归', updateDate: '2026-08-03' },
      { num: 2, title: '第一具尸体', updateDate: '2026-07-31' },
      { num: 3, title: '心理画像', updateDate: '2026-07-28' },
      { num: 4, title: '模仿犯', updateDate: '2026-07-25' },
      { num: 5, title: '真相大白', updateDate: '2026-07-22' },
    ],
    rating: 9.6,
    views: 920000,
    tags: ['悬疑', '推理', '犯罪心理'],
    isHot: true,
    isNew: false,
    isCompleted: false,
    updateDate: '2026-08-03',
  },
  {
    id: 'comic-13',
    title: '我的邻居是吸血鬼',
    author: '李夏恩',
    category: 'gaoxiao',
    categoryName: '搞笑',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20supernatural%20comedy%20comic%20cover%2C%20funny%20vampire%20in%20modern%20apartment%20setting%2C%20quirky%20characters%2C%20bright%20playful%20style%2C%20humorous%20expression%2C%20clean%20light%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-13&orientation=portrait',
    description: '搬进新公寓后发现隔壁住着一个几百岁的吸血鬼？！但这个吸血鬼完全不像传说中那样可怕——他怕血、爱追剧、沉迷外卖，还暗恋着楼下咖啡店的女孩。',
    chapters: [
      { num: 1, title: '新邻居', updateDate: '2026-07-29' },
      { num: 2, title: '吸血鬼的秘密', updateDate: '2026-07-26' },
      { num: 3, title: '外卖风波', updateDate: '2026-07-23' },
    ],
    rating: 9.1,
    views: 780000,
    tags: ['搞笑', '奇幻', '日常'],
    isHot: false,
    isNew: true,
    isCompleted: false,
    updateDate: '2026-07-29',
  },
  {
    id: 'comic-14',
    title: '重生之商业帝国',
    author: '赵敏俊',
    category: 'dushi',
    categoryName: '都市',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20business%20drama%20comic%20cover%2C%20confident%20CEO%20in%20luxurious%20office%20with%20city%20skyline%2C%20sophisticated%20modern%20style%2C%20success%20and%20ambition%20theme%2C%20clean%20professional%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-14&orientation=portrait',
    description: '商界传奇人物在临终前重生回到了二十年前。带着前世的记忆和经验，他要在这次人生中打造一个前所未有的商业帝国，同时弥补那些曾经留下的遗憾。',
    chapters: [
      { num: 1, title: '重生', updateDate: '2026-08-02' },
      { num: 2, title: '第一桶金', updateDate: '2026-07-30' },
      { num: 3, title: '商场如战场', updateDate: '2026-07-27' },
      { num: 4, title: '昔日对手', updateDate: '2026-07-24' },
      { num: 5, title: '帝国崛起', updateDate: '2026-07-21' },
    ],
    rating: 9.2,
    views: 1100000,
    tags: ['都市', '重生', '商战'],
    isHot: false,
    isNew: false,
    isCompleted: false,
    updateDate: '2026-08-02',
  },
  {
    id: 'comic-15',
    title: '妖精的尾巴',
    author: '姜瑞妍',
    category: 'qihuan',
    categoryName: '奇幻',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fairy%20tale%20fantasy%20comic%20cover%2C%20beautiful%20fairy%20with%20glowing%20wings%20in%20enchanted%20forest%2C%20magical%20sparkles%2C%20ethereal%20dreamy%20mood%2C%20soft%20green%20and%20gold%20tones%2C%20clean%20light%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-15&orientation=portrait',
    description: '在人类与妖精共存的世界里，一位拥有特殊能力的少女踏上了寻找失踪母亲的旅程。一路上她结识了各种奇妙的妖精伙伴，逐渐揭开世界的秘密。',
    chapters: [
      { num: 1, title: '启程', updateDate: '2026-07-31' },
      { num: 2, title: '迷雾森林', updateDate: '2026-07-28' },
      { num: 3, title: '妖精王庭', updateDate: '2026-07-25' },
    ],
    rating: 9.3,
    views: 860000,
    tags: ['奇幻', '冒险', '友情'],
    isHot: false,
    isNew: false,
    isCompleted: false,
    updateDate: '2026-07-31',
  },
  {
    id: 'comic-16',
    title: '霸道总裁爱上我',
    author: '韩素希',
    category: 'lianai',
    categoryName: '恋爱',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20CEO%20romance%20comic%20cover%2C%20handsome%20CEO%20in%20designer%20suit%20with%20ordinary%20girl%2C%20luxurious%20setting%2C%20romantic%20dramatic%20mood%2C%20warm%20elegant%20color%20palette%2C%20clean%20light%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-16&orientation=portrait',
    description: '平凡的女孩意外成为了霸道总裁的私人助理。从最初的针锋相对到渐渐心动，她在华丽的都市丛林中找到了属于自己的幸福。',
    chapters: [
      { num: 1, title: '面试', updateDate: '2026-08-01' },
      { num: 2, title: '第一天上班', updateDate: '2026-07-28' },
      { num: 3, title: '出差之旅', updateDate: '2026-07-25' },
      { num: 4, title: '意外的吻', updateDate: '2026-07-22' },
    ],
    rating: 9.4,
    views: 1320000,
    tags: ['恋爱', '都市', '甜宠'],
    isHot: true,
    isNew: false,
    isCompleted: false,
    updateDate: '2026-08-01',
  },
  {
    id: 'comic-17',
    title: '电竞之王',
    author: '文俊辉',
    category: 'dongzuo',
    categoryName: '动作',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20esports%20action%20comic%20cover%2C%20professional%20gamer%20with%20headset%20in%20arena%20with%20colorful%20lights%2C%20intense%20competitive%20atmosphere%2C%20cyberpunk%20inspired%20style%2C%20clean%20dark%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-17&orientation=portrait',
    description: '天才电竞少年在职业赛场上所向披靡，但一个神秘新人的出现打破了他的连胜纪录。两人之间的巅峰对决，不仅关乎荣誉，更牵动着整个电竞圈的格局。',
    chapters: [
      { num: 1, title: '出道战', updateDate: '2026-08-02' },
      { num: 2, title: '神秘对手', updateDate: '2026-07-30' },
      { num: 3, title: '训练营', updateDate: '2026-07-27' },
    ],
    rating: 9.0,
    views: 690000,
    tags: ['动作', '电竞', '竞技'],
    isHot: false,
    isNew: true,
    isCompleted: false,
    updateDate: '2026-08-02',
  },
  {
    id: 'comic-18',
    title: '时间旅行者的妻子',
    author: '姜河那',
    category: 'juqing',
    categoryName: '剧情',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20time%20travel%20romance%20drama%20comic%20cover%2C%20couple%20separated%20by%20time%20with%20vintage%20clock%20motif%2C%20melancholic%20beautiful%20atmosphere%2C%20warm%20sepia%20tones%2C%20emotional%20and%20poetic%2C%20clean%20light%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-18&orientation=portrait',
    description: '他拥有穿越时间的能力，却无法控制自己的去向。她选择了一直等待，因为爱超越了时间的界限。一段跨越时空的爱情，温暖而令人心碎。',
    chapters: [
      { num: 1, title: '初次相遇', updateDate: '2026-07-30' },
      { num: 2, title: '消失的他', updateDate: '2026-07-27' },
      { num: 3, title: '等待', updateDate: '2026-07-24' },
    ],
    rating: 9.7,
    views: 780000,
    tags: ['剧情', '恋爱', '科幻'],
    isHot: false,
    isNew: false,
    isCompleted: true,
    updateDate: '2026-07-30',
  },
  {
    id: 'comic-19',
    title: '幽灵侦探社',
    author: '柳承范',
    category: 'xuanyi',
    categoryName: '悬疑',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20supernatural%20mystery%20comic%20cover%2C%20ghost%20detective%20with%20magnifying%20glass%20in%20old%20mansion%2C%20spooky%20but%20stylish%20atmosphere%2C%20purple%20and%20dark%20blue%20tones%2C%20clean%20dark%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-19&orientation=portrait',
    description: '能看见鬼魂的少女成立了一家特殊的侦探社，专门解决与超自然现象有关的案件。每一个委托背后都隐藏着令人意想不到的真相。',
    chapters: [
      { num: 1, title: '开张', updateDate: '2026-07-31' },
      { num: 2, title: '第一个委托', updateDate: '2026-07-28' },
      { num: 3, title: '校园怪谈', updateDate: '2026-07-25' },
    ],
    rating: 9.2,
    views: 650000,
    tags: ['悬疑', '灵异', '推理'],
    isHot: false,
    isNew: true,
    isCompleted: false,
    updateDate: '2026-07-31',
  },
  {
    id: 'comic-20',
    title: '高校嘻哈社',
    author: '金南俊',
    category: 'xiaoyuan',
    categoryName: '校园',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20hiphop%20school%20music%20comic%20cover%2C%20students%20dancing%20and%20rapping%20with%20microphone%2C%20vibrant%20energetic%20style%2C%20graffiti%20inspired%20colorful%20background%2C%20youth%20culture%20theme%2C%20clean%20dynamic%20layout%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-20&orientation=portrait',
    description: '一群热爱嘻哈文化的高中生决定组建自己的社团。在音乐的陪伴下，他们用说唱表达自我，用舞蹈释放青春，书写属于他们的热血故事。',
    chapters: [
      { num: 1, title: '社团招新', updateDate: '2026-07-29' },
      { num: 2, title: '第一次公演', updateDate: '2026-07-26' },
      { num: 3, title: '对手出现', updateDate: '2026-07-23' },
    ],
    rating: 8.9,
    views: 580000,
    tags: ['校园', '音乐', '青春'],
    isHot: false,
    isNew: false,
    isCompleted: false,
    updateDate: '2026-07-29',
  },
  {
    id: 'comic-21',
    title: '九尾狐传',
    author: '林允儿',
    category: 'qihuan',
    categoryName: '奇幻',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mythology%20fantasy%20comic%20cover%2C%20beautiful%20nine%20tailed%20fox%20spirit%20in%20traditional%20Korean%20hanbok%2C%20mystical%20ancient%20atmosphere%2C%20elegant%20red%20and%20gold%20tones%2C%20clean%20light%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-21&orientation=portrait',
    description: '修行千年的九尾狐为了变成人类，必须完成一个神秘的任务——找到失落的三件神器。在寻找的过程中，她遇到了命中注定的人类男子。',
    chapters: [
      { num: 1, title: '千年修行', updateDate: '2026-08-02' },
      { num: 2, title: '人间', updateDate: '2026-07-30' },
      { num: 3, title: '第一件神器', updateDate: '2026-07-27' },
      { num: 4, title: '命运之人', updateDate: '2026-07-24' },
    ],
    rating: 9.5,
    views: 1180000,
    tags: ['奇幻', '恋爱', '神话'],
    isHot: true,
    isNew: false,
    isCompleted: false,
    updateDate: '2026-08-02',
  },
  {
    id: 'comic-22',
    title: '健身房的故事',
    author: '裴秀智',
    category: 'gaoxiao',
    categoryName: '搞笑',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fitness%20comedy%20comic%20cover%2C%20funny%20characters%20working%20out%20in%20gym%2C%20humorous%20exaggerated%20expressions%2C%20bright%20energetic%20style%2C%20clean%20light%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-22&orientation=portrait',
    description: '一家小小的社区健身房里，聚集了各种有趣的人——永远在减肥的老板娘、肌肉痴迷的教练、以及一群健身小白。他们的日常充满了欢乐与汗水。',
    chapters: [
      { num: 1, title: '入会', updateDate: '2026-07-28' },
      { num: 2, title: '深蹲地狱', updateDate: '2026-07-25' },
      { num: 3, title: '蛋白粉风波', updateDate: '2026-07-22' },
    ],
    rating: 8.8,
    views: 520000,
    tags: ['搞笑', '日常', '健身'],
    isHot: false,
    isNew: false,
    isCompleted: false,
    updateDate: '2026-07-28',
  },
  {
    id: 'comic-23',
    title: '深夜的钢琴声',
    author: '全智贤',
    category: 'juqing',
    categoryName: '剧情',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20music%20drama%20comic%20cover%2C%20pianist%20playing%20grand%20piano%20in%20moonlit%20room%2C%20melancholic%20beautiful%20atmosphere%2C%20soft%20blue%20and%20silver%20tones%2C%20emotional%20depth%2C%20clean%20dark%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-23&orientation=portrait',
    description: '一位失意的钢琴家在深夜的琴房里遇到了一个神秘的小女孩。女孩对音乐的天赋和纯真打动了他，让他重新找回了对音乐的热爱和人生的意义。',
    chapters: [
      { num: 1, title: '最后一曲', updateDate: '2026-07-30' },
      { num: 2, title: '月光下的女孩', updateDate: '2026-07-27' },
      { num: 3, title: '重新开始', updateDate: '2026-07-24' },
      { num: 4, title: '音乐会', updateDate: '2026-07-21' },
    ],
    rating: 9.6,
    views: 610000,
    tags: ['剧情', '音乐', '治愈'],
    isHot: false,
    isNew: false,
    isCompleted: true,
    updateDate: '2026-07-30',
  },
  {
    id: 'comic-24',
    title: '首尔地下铁',
    author: '朴宝剑',
    category: 'dushi',
    categoryName: '都市',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20urban%20slice%20of%20life%20comic%20cover%2C%20people%20in%20Seoul%20subway%20station%2C%20modern%20city%20life%2C%20realistic%20warm%20style%2C%20everyday%20scenes%2C%20clean%20light%20background%2C%20vertical%20book%20cover%20layout&width=600&height=800&seq=comic-cover-24&orientation=portrait',
    description: '首尔地铁每天承载着数百万人的故事。四个不同背景的年轻人因地铁而结缘，他们的人生轨迹在城市的轨道上交错、分离、再重合。',
    chapters: [
      { num: 1, title: '一号线', updateDate: '2026-07-31' },
      { num: 2, title: '换乘站', updateDate: '2026-07-28' },
      { num: 3, title: '末班车', updateDate: '2026-07-25' },
    ],
    rating: 9.1,
    views: 540000,
    tags: ['都市', '剧情', '日常'],
    isHot: false,
    isNew: false,
    isCompleted: false,
    updateDate: '2026-07-31',
  },
];

export const siteInfo = {
  name: '韩漫漫画网',
  tagline: '免费漫画大全 - 高清韩国漫画 - 无遮挡下拉式韩漫在线阅读',
  description: '韩漫漫画网提供免费漫画大全，高清韩国漫画采用无遮挡下拉式在线阅读，界面简洁，加载迅速，让您享受流畅浏览过程。',
  keywords: '韩漫,免费,漫画大全,高清韩国漫画,无遮挡,下拉式,在线阅读',
  url: 'https://www.hanmancomic.com',
  email: 'contact@hanmancomic.com',
  phone: '400-888-0000',
  address: '北京市朝阳区望京SOHO T1',
  foundingYear: '2020',
};